import { render } from "./IconHelp.vue?vue&type=template&id=7207e162"
import script from "./IconHelp.vue?vue&type=script&lang=ts"
export * from "./IconHelp.vue?vue&type=script&lang=ts"
script.render = render

export default script